export default __webpack_public_path__ + "static/media/vc.0a5c9477.svg";